import { ReactNode } from 'react';
import { SxProps, Theme, Typography } from '@mui/material';
import { spreadSx } from 'ui-kit/lib/utils/spreadSx';

export const Text = ({
  children,
  sx,
}: {
  children: ReactNode;
  sx?: SxProps<Theme>;
}) => (
  <Typography
    variant={'body1'}
    sx={[
      {
        fontWeight: { xs: 500, sm: 500 },
        lineHeight: { xs: '18px', sm: '24px', lg: '30px' },
        fontSize: { xs: '12px', sm: '14px', lg: '18px' },
      },
      ...spreadSx(sx),
    ]}
    component={'p'}
  >
    {children}
  </Typography>
);
